import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About-gmf";
import Gmfguideline from "./Pages/Gmfguideline";
import Gmfindia from "./Pages/Gmfindia";
import Gmfspain from "./Pages/Gmfspain";
import Gmflatinamerica from "./Pages/Gmflatinamerica";
import Gmfmexico from "./Pages/Gmf-mexico";
import Gmfmalaysia from "./Pages/Gmfmalaysia";
import Gmfitaly from "./Pages/Gmfitaly";
import Gmfmadagascar from "./Pages/Gmfmadagascar";
import Boardmembers from "./Pages/Boardmembers";
import Journey from "./Pages/Journey";
import Champaran from "./Pages/Champaran";
import Champaran_Satyagrah from "./Pages/Champaran_Satyagrah";
import SatyagrahaEternalJourney from "./Pages/satyagrahaeternaljourney";
import News from "./Pages/News-media";
import Pressrelease from "./Pages/Pressrelease";
import Gallery from "./Pages/Gallery";
import Nelsonmandeladay from "./Pages/Nelsonmandeladay";
import Yogaday from "./Pages/Yogaday";
import Charitableactivities from "./Pages/Charitable-activities";
import Error404 from "./Pages/Error404";
import Contact from "./Pages/Contact";
import Gandhimandelalegacy from "./Pages/Gandhimandelalegacy";
import ChessForPeace from "./Pages/Chess-for-peace";

function InternalLinkHandler() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleClick = (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const link = event.target.closest("a");
      if (!link || link.target || link.hasAttribute("download")) {
        return;
      }

      const href = link.getAttribute("href");
      if (
        !href ||
        href === "#" ||
        href.startsWith("#") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        href.startsWith("http")
      ) {
        return;
      }

      if (href.startsWith("/") || href === "contact") {
        event.preventDefault();
        navigate(href.startsWith("/") ? href : `/${href}`);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [navigate]);

  return null;
}

function App() {
  return (
    <Router>
      <InternalLinkHandler />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-gmf" element={<About />} />
        <Route path="/gmfguideline" element={<Gmfguideline />} />
        <Route path="/gmfindia" element={<Gmfindia />} />
        <Route path="/gmfmalaysia" element={<Gmfmalaysia />} />
        <Route path="/gmflatinamerica" element={<Gmflatinamerica />} />
        <Route path="/gmf-mexico" element={<Gmfmexico />} />
        <Route path="/gmfspain" element={<Gmfspain />} />
        <Route path="/gmfitaly" element={<Gmfitaly />} />
        <Route path="/gmfmadagascar" element={<Gmfmadagascar />} />
        <Route path="/boardmembers" element={<Boardmembers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/yogaday" element={<Yogaday />} />
        <Route
          path="/charitable-activities"
          element={<Charitableactivities />}
        />
        <Route path="/nelsonmandeladay" element={<Nelsonmandeladay />} />
        <Route path="/gandhimandelalegacy" element={<Gandhimandelalegacy />} />
        <Route
          path="/satyagrahaeternaljourney"
          element={<SatyagrahaEternalJourney />}
        />
        <Route path="/journey" element={<Journey />} />
        <Route path="/champaran" element={<Champaran />} />
        <Route path="/champaran_satyagrah" element={<Champaran_Satyagrah />} />
        <Route path="/news-media" element={<News />} />
        <Route path="/pressrelease" element={<Pressrelease />} />
        <Route path="/chess-for-peace" element={<ChessForPeace />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
